import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui";
import type { TourStep } from "../data/tourSteps";

interface TourTooltipProps {
  step: TourStep;
  currentStep: number;
  totalSteps: number;
  position: { top: number; left: number };
  onNext: () => void;
  onPrev: () => void;
  onSkip: () => void;
}

export function TourTooltip({
  step,
  currentStep,
  totalSteps,
  position,
  onNext,
  onPrev,
  onSkip,
}: TourTooltipProps) {
  const isFirst = currentStep === 0;
  const isLast = currentStep === totalSteps - 1;

  return (
    <div
      className="fixed z-[10001] w-[calc(100vw-2rem)] max-w-80 bg-card border border-border rounded-lg shadow-xl"
      style={{
        top: position.top,
        left: position.left,
        transition: "top 0.2s ease-out, left 0.2s ease-out",
      }}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 pt-3 pb-1">
        <h3 className="text-sm font-semibold text-foreground">{step.title}</h3>
        <button
          onClick={onSkip}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      {/* Content */}
      <div className="px-4 pb-3">
        <p className="text-sm text-muted-foreground">{step.content}</p>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between px-4 pb-3">
        <span className="text-xs text-muted-foreground">
          {currentStep + 1} / {totalSteps}
        </span>
        <div className="flex items-center gap-2">
          {!isFirst && (
            <Button variant="ghost" size="sm" onClick={onPrev}>
              <ChevronLeft className="w-4 h-4" />
              Wstecz
            </Button>
          )}
          {isLast ? (
            <Button size="sm" onClick={onSkip}>
              Zakończ
            </Button>
          ) : (
            <Button size="sm" onClick={onNext}>
              Dalej
              <ChevronRight className="w-4 h-4" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
